export const API_PATH_apiUserInvitationGet = '/services/user-invitation';
